import React from "react";

function cls(status) {
  switch (status) {
    case "Incomplete": return "status-incomplete";
    case "Needs Review": return "status-needs-review";
    case "Internally Ready": return "status-internally";
    case "Client-Ready": return "status-client";
    case "Corporate-Ready": return "status-corporate";
    case "Attorney Review Required": return "status-attorney";
    case "Restricted": return "status-restricted";
    case "Ineligible": return "status-ineligible";
    default: return "status-incomplete";
  }
}

export default function StatusBadge({ status, className = "", "data-testid": testId }) {
  return (
    <span
      data-testid={testId || "status-badge"}
      className={`inline-flex items-center px-2.5 py-1 text-[11px] font-medium rounded-md border ${cls(status)} ${className}`}
    >
      {status || "—"}
    </span>
  );
}

export function DocStatusBadge({ status, className = "" }) {
  const map = {
    "Missing": "doc-missing",
    "Requested": "doc-requested",
    "Received": "doc-received",
    "Under Review": "doc-under-review",
    "Accepted": "doc-accepted",
    "Rejected": "doc-rejected",
    "Attorney Review Required": "doc-attorney",
    "Archived Offline": "doc-archived",
    // Kandake Document Repository (Locked Spec) — vault status equivalents.
    "Uploaded": "doc-received",
    "Verified / Approved": "doc-accepted",
    "Superseded": "doc-archived",
    "Expired": "doc-rejected",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium rounded ${map[status] || "doc-missing"} ${className}`}>
      {status || "—"}
    </span>
  );
}
